import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from 'seagull';
import { useLocaleKeys } from '~/i18n';
export const AddTimeActivityButton = (param)=>{
    let { onAdd, bi, testId } = param;
    const { t } = useLocaleKeys('components.billClientModal.timeActivities');
    return /*#__PURE__*/ _jsx(Button, {
        bi: bi,
        testId: testId,
        onClick: onAdd,
        children: t.add()
    });
};
